var render = function render(){var _vm=this,_c=_vm._self._c;return _c('coozzy-card',[_c('h5',{staticClass:"mb-0 title-card"},[_vm._v(" "+_vm._s(_vm.title)),(_vm.statistics)?_c('span',{staticClass:"text-blue"},[_vm._v(" | "),_c('b',[_vm._v(_vm._s(_vm.statistics))]),_vm._v(" "+_vm._s(_vm.objects)+" ")]):_vm._e()]),_c('div',{staticClass:"col body text-center bottom_radius"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }